import * as React from 'react';
import { useState } from 'react';
import * as Yup from 'yup';
import { Overlay, SideModal, SideModalContent } from '~/common/layout/Modals';
import Head from '~/common/layout/Head';
import PaycodeConfirmation from './PaycodeConfirmation';
import PaycodesFormEmailOrSms from 'apps/sender/components/codes/PaycodesFormEmailOrSms';
import FormikForm from '~/lib/forms/FormikForm';
import { emailRegExp, phoneRegExp } from '~/apps/shared/consts';

export class sendToName {
  static MAIL = 'to-mail';
  static SMS = 'to-sms';
}

class Message {
  static SUCCESS = 'The message has been sent';
  static FAILED = 'Bad request';
}

const sendSchema = Yup.object().shape({
  phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  email: Yup.string().matches(emailRegExp, 'Email is not valid'),
});

export default (props) => {
  const { headTitle, onClose, paycode, onEdit, onDelete, organization, handleActions } = props;
  const [sendTo, setSendTo] = useState(null);
  const [info, setInfo] = useState(null);
  const [infoMessage, setInfoMessage] = useState({
    isError: false,
    message: '',
  });

  const setSuccessInfo = () => setInfo(<div
    className="m__body__titl--lg"
    style={{
      color: 'white',
      textTransform: 'uppercase',
      fontSize: '2rem',
      fontWeight: 'bold',
    }}>{Message.SUCCESS}</div>);

  const setFailedInfo = () => setInfo(<div
    className="m__body__titl--lg"
    style={{
      color: 'red',
      textTransform: 'uppercase',
      fontSize: '2rem',
    }}>{Message.FAILED}</div>);

  const clearInfo = () => setInfo(null);

  const selectInfo = (type = 0) => {
    switch (type) {
      case 1:
        setSuccessInfo();
        break;
      case 2:
        setFailedInfo();
        break;
      default:
        clearInfo();
        break;
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    onClose();
  };

  const handleOpenFormEmail = (e) => {
    e.preventDefault();
    selectInfo();
    setSendTo(sendToName.MAIL)
  };

  const handleOpenFormText = (e) => {
    e.preventDefault();
    selectInfo();
    setSendTo(sendToName.SMS)
  };

  const handleEdit = (e, paycode) => {
    e.preventDefault();
    onEdit(paycode);
  };

  const handleDelete = (e, paycode) => {
    e.preventDefault();
    onDelete(paycode);
  };

  const clearMessage = () => {
    setInfoMessage({
      isError: false,
      message: '',
    });
  };

  const cbResponse = (result) => {
    if (!result.success) {
      selectInfo(2);
      // setInfoMessage({
      //   isError: true,
      //   message: result.error,
      // });
    } else {
      selectInfo(1);
      // setInfoMessage({
      //   isError: false,
      //   message: result.error,
      // });
    }
  };

  const handleSends = (action, options = {}) => {
    switch (action) {
      case 'receipt-text':
        clearMessage();
        setSendTo(sendToName.SMS);
        break;

      case 'receipt-email':
        clearMessage();
        setSendTo(sendToName.MAIL);
        break;

      case 'send-to-sms':
        handleActions('request-sms', { ...options, cb: cbResponse });
        setSendTo(null);
        break;

      case 'send-to-email':
        handleActions('request-email', { ...options, cb: cbResponse });
        setSendTo(null);
        break;

      case 'cancel-send':
        setInfoMessage({
          isError: false,
          message: '',
        });
        setSendTo(null);
        break;

      default:
        break;
    }
  };

  return (
    <FormikForm
      initialValues={{
        phone: '',
        email: '',
      }}
      validationSchema={sendSchema}
      render={(propsForm) => {
        const { errors, values: { phone, email } } = propsForm;
        const isErrPhone = errors.hasOwnProperty('phone') || !phone;
        const isErrEmail = errors.hasOwnProperty('email') || !email;

        return (
          <Overlay onClick={onClose}>
            <SideModal>
              <Head headTitle={headTitle}>
                <a
                  href="javascript:void(null)"
                  className="btn btn--prim btn--md"
                  onClick={(e) => handleEdit(e, paycode)}
                >Edit</a>
                <a
                  href="javascript:void(null)"
                  className="btn btn--warn btn--md"
                  onClick={(e) => handleDelete(e, paycode)}
                >Delete</a>
              </Head>

              <SideModalContent>
                <PaycodeConfirmation
                  onClose={handleClose}
                  onEmail={handleOpenFormEmail}
                  onText={handleOpenFormText}
                  paycode={paycode}
                  organization={organization}
                  displaySendCode={sendTo}
                  infoResult={info}
                />
                <br />
                <br />
                <PaycodesFormEmailOrSms
                  sendTo={sendTo}
                  handleSends={handleSends}
                  options={{ paycode: props.paycode.id, phone, email }}
                  infoMessage={infoMessage}
                  isErrPhone={isErrPhone}
                  isErrEmail={isErrEmail}
                />
              </SideModalContent>
            </SideModal>
          </Overlay>
        );
      }}
    />
  );
};
